import { motion } from "framer-motion"

export default function IncomingSignalFeed({ logs }) {
  const formatTimeAgo = (timestamp) => {
    const now = new Date()
    const signalTime = new Date(timestamp)
    const diffMs = now.getTime() - signalTime.getTime()
    const diffMinutes = Math.round(diffMs / (1000 * 60))
    const diffHours = Math.round(diffMs / (1000 * 60 * 60))

    if (diffMinutes < 1) return "just now"
    if (diffMinutes < 60) return `${diffMinutes}m ago`
    if (diffHours < 24) return `${diffHours}h ago`
    return signalTime.toLocaleDateString()
  }

 const getSignalColorChar = (score) => {
    if (score >= 85) {
      return "239, 68, 68"
    } else if (score >= 70) {
      return "249, 115, 22"
    } else if (score >= 50) {
      return "234, 179, 8"
    } else {
      return "34, 197, 94"
    }
  }

  const filteredLogs = logs

  const cleanSignal = (signal) => {
    return signal.replace(/^\*+\s*"?|"?$/g, "").trim() || null;
  }

  return (
    <div className="w-full bg-gray-100 p-4 border-t border-gray-300 radar-Guide-step-5">
      <h3 className="text-sm mb-2">INCOMING SIGNAL FEED</h3>
      <div className="flex flex-col gap-2 overflow-y-auto max-h-[150px] pr-2">
        {filteredLogs.map((log, index) => (
          <motion.div
            key={log.id}
            className="flex items-center gap-2 text-xs whitespace-nowrap"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
          >
            <div
              className="w-3 h-3 rounded-full flex-shrink-0"
              style={{ backgroundColor: `rgba(${getSignalColorChar(log.score)})` }}
            />
            <span className="flex-shrink-0">{formatTimeAgo(log.timestamp)}:</span>
            <span className="font-semibold flex-shrink-0">{log.signal_type.replace(/\*\*/g, "")} —</span>
            <span>
             (<span className="font-semibold">Score</span>: {log.score}) {cleanSignal(log.raw_signal)}
            </span>
          </motion.div>
        ))}
      </div>
    </div>
  )
}
